import type { components } from '@pba/types-openapi-client';
import type { ChangeRequestDataObject, ChangeRequestMetaDataObject } from './services';

export type ChangeRequest = {
  createdAt: Date;
  createdUser: {
    fullName: string;
    id: string;
  };
  id: string;
  kind: ChangeRequestKind;
  meta: {
    birthdate?: string;
    firstName?: string;
    invitationEmail?: string;
    invitationPhone?: string;
    invitationToken?: string;
    lastName?: string;
    reasonToJoin?: string;
  };
  status: ChangeRequestStatus;
  subject: {
    name: string;
    subjectId: string;
    subjectType: string;
  };
  updatedAt: string;
};

export type ChangeRequestKind = components['schemas']['ChangeRequestKindEnum'];

export type ChangeRequestStatus = components['schemas']['ChangeRequestStatusEnum'];

export const createChangeRequest = (data: ChangeRequestDataObject): ChangeRequest => {
  const meta = data.meta as ChangeRequestMetaDataObject | undefined;

  return {
    createdAt: new Date(data.created_at),
    createdUser: {
      fullName: data.created_user.full_name ?? '',
      id: data.created_user.id ?? '',
    },
    id: data.id,
    kind: data.kind,
    meta: {
      birthdate: meta?.birthdate,
      firstName: meta?.first_name,
      invitationEmail: meta?.invitation_email,
      invitationPhone: meta?.invitation_phone,
      invitationToken: meta?.invitation_token,
      lastName: meta?.last_name,
      reasonToJoin: meta?.reason_to_join,
    },
    status: data.status,
    subject: {
      name: data.subject?.name ?? '',
      subjectId: data.subject?.subject_id ?? '',
      subjectType: data.subject?.subject_type ?? '',
    },
    updatedAt: data.updated_at,
  };
};
